import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { HiMail } from "react-icons/hi";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { TbBrandTelegram } from "react-icons/tb";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
			<h1 style={{ fontSize: "2.6em" }}>
			  GET TO KNOW <span className="purple">ME</span>
			</h1>

            <p className="home-about-body">
              Hi there! I'm <span className="purple">Basel Ashraf Fikry</span>, a passionate machine learning engineer with a strong background in computer engineering and software systems.
              <br />
              <br />
              My expertise lies in building innovative <b className="purple">machine learning models</b> and <b className="purple">data-driven solutions</b> to tackle real-world problems. I'm fluent in programming languages like <i><b className="purple">Python</b></i> and <i><b className="purple">JavaScript</b></i>.
              <br />
              <br />
              I'm deeply interested in <b className="purple">deep learning</b>, <b className="purple">computer vision</b>, and <b className="purple">natural language processing</b>, and I love exploring new advancements in these fields.
              <br />
              <br />
              When I'm not diving into the world of machine learning, you can find me exploring new technologies, contributing to open-source projects, and attending tech meetups and conferences.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>---------</h1>
            <p>
              Let's <span className="purple">collaborate! </span>
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/BaselAshraf81"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/basel-askar/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
			  <li className="social-icons">
				<a href="mailto:u2679054@uel.ac.uk"
				  className="icon-colour  home-social-icons">
				  <HiMail /> {/* Using the email icon */}
				</a>
			  </li>
			   <li className="social-icons">
                <a
                  href="https://t.me/qwerty123082"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <TbBrandTelegram /> {/* Telegram icon */}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
